import { NumberFieldProps, NumberField } from 'react-admin';

type Props = NumberFieldProps & {nullable?: boolean};

export const MoneyField = ({ nullable, locales = 'en-US', ...restProps }: Props) => {
  return (
    <NumberField
      style={{ whiteSpace: 'nowrap' }}
      options={{ style: 'currency', currency: 'USD', currencyDisplay: 'symbol' }}
      locales={locales}
      emptyText={nullable ? '' : '$ 0'}
      {...restProps}
    />
  );
};
